<template>
  <div id="expensesPaidComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex class="text-sm-right" xs2 sm2>
            <v-menu v-model="menuP" ref="menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="startDate" :label="$t('employerReports.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" v-model="startDate" @input="menu = false" :max="today" :locale="$t('reportsType.local')" @change="limiteRangeDay()">
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="text-sm-right" xs2 sm2>
          <v-menu ref="menu2" v-model="menuP2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" :label="$t('employerReports.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="endDate" :min="startDate" :locale="$t('reportsType.local')" @input="menu = false" @change="limiteRangeDayEndDate()">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn color="primary" icon @click="searchByDates()">
          <v-icon>search</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field type="number" v-model="searchExpensesId" @keydown.enter="searchByExpensesId()" min="0" :label="$t('expenses.idExpenseSearch')"></v-text-field>
        <v-btn color="primary" round outline @click="downloadReport" :loading="loadingDownload">
          <v-icon left>cloud_download</v-icon>
          {{ $t('general.downloadReport') }}
        </v-btn>
        <v-btn v-if="applyFeaturesBtnERP" color="primary" round outline @click="createLayoutERP">
          <v-icon left>menu</v-icon>
          {{ $t('general.generateLayoutERP') }}
        </v-btn>
        <v-btn :hidden="hiddenDownloadLayout" @click="downloadLayoutERP" :loading="loadingDownload" slot="activator" color="primary" round outline>
            <v-icon left>download</v-icon>
            {{ $t('general.downloadLayout') }}
        </v-btn>
      </v-layout>
      <v-toolbar flat color="bg-sidebar" dark>
        <h2 class="my-0">{{heading}}</h2>
        <v-spacer></v-spacer>
        <v-text-field color="light" v-model="search" :label="$t('general.filter')"></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="expensesPaid"
        :loading="loadingDataTable"
        :rows-per-page-items="[10, 15, 25]"
        :pagination.sync="pagination"
        class="elevation-1">
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'font-weight-black white--text column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="grey lighten-3">
            <td class="font-weight-black" style="max-width: 30px">
              <v-tooltip bottom v-if="props.item">
                <template v-slot:activator="{ on }">
                  <v-icon  @click="props.expanded = !props.expanded" v-if="!props.expanded" v-on="on" color="primary">mdi-chevron-down</v-icon>
                  <v-icon  @click="props.expanded = !props.expanded" v-else v-on="on" color="primary">mdi-chevron-up</v-icon>
                </template>
                <span>{{!props.expanded ? $t('general.extend') : $t('general.collapse')}}</span>
              </v-tooltip>
            </td>
            <td width="60px">
              <div class="checkbox-and-data text-sm-center text-center">
                <v-checkbox :hidden="hiddenCheck" v-model="props.item.isChecked"  @change="handleCheckboxChange()" class="custom-checkbox"></v-checkbox>
              </div>
              <div class="d-inline-flex align-items-center justify-center">
                <span>{{ props.item.id }}</span>
                <v-tooltip v-if="props.item.erp_export_log.length > 0" top>
                  <template v-slot:activator="{ on }">
                    <v-icon style="vertical-align: middle; margin-left: 4px;" class="primary--text" v-on="on" small>download</v-icon>
                  </template>
                  <span>{{ $t('general.erpExportLogOne') }}</span>
                </v-tooltip>
              </div>
            </td>
            <td class="text-sm-center">{{ props.item.user.name }}</td>
            <td class="text-sm-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon style="vertical-align: middle" v-if="props.item.is_petty_cash === 1" class="primary--text" v-on="on">stars</v-icon>
                </template>
                <span>{{ $t('expenses.pettyExpense') }}</span>
              </v-tooltip>
              {{ props.item.description }}
            </td>
            <td class="text-sm-center">{{ props.item.project.name }}</td>
            <td class="text-sm-center">{{ props.item.start_date }} / {{props.item.end_date}}</td>
            <td class="text-sm-center">{{ props.item.advance | formatCurrency }}</td>
            <td class="text-sm-center">{{ props.item.suma_total_items | formatCurrency }}</td>
            <td class="text-sm-center">
              <v-layout row justify-center>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn :disabled="isDisabled(props.item.gst_expenses_items)" small outline icon color="info" v-on="on" @click="getAcuse(props.item.id)">
                        <v-icon small>receipt</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ $t('expenses.downloadAccuse') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-layout>
              <v-flex xs12>
                <h2 class="primary--text text-sm-left ml-3 mt-2">
                  {{ $t('general.expenseItems') }}:
                </h2>
              </v-flex>
            </v-layout>
            <v-layout v-if="props.item.gst_expenses_items.length === 0">
              <v-flex xs12>
                <p class="text-sm-left ml-4">{{ $t('history.noItem') }}</p>
              </v-flex>
            </v-layout>
            <v-layout v-if="props.item.gst_expenses_items.length !== 0">
              <v-flex xs12>
                <table width="100%">
                  <thead>
                    <th class="text-sm-center">#</th>
                    <th class="text-sm-center">
                      {{ $t('general.description') }}
                    </th>
                    <th class="text-sm-center">
                      {{ $t('general.subtotal') }}
                    </th>
                    <th class="text-sm-center">
                      {{ $t('general.total') }}
                    </th>
                    <th class="text-sm-center">
                      {{ $t('general.comment') }}
                    </th>
                    <th class="text-sm-center">
                      {{ $t('general.actions') }}
                    </th>
                  </thead>
                  <tr v-for="item of props.item.gst_expenses_items" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td class="text-sm-center">{{ item.description }}</td>
                    <td class="text-sm-center">
                      {{ item.subtotal | formatCurrency }}
                    </td>
                    <td class="text-sm-center">
                      {{ item.total | formatCurrency }}
                    </td>
                    <td class="text-sm-center">{{ item.comment }}</td>
                    <td class="text-sm-center">
                      <v-tooltip top v-if="item.file_attach.length > 0">
                        <template v-slot:activator="{ on }">
                          <v-btn @click="attachFiles(item)" small icon outline color="primary" v-on="on">
                            <v-icon small>attach_file</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.attachedFiles') }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small outline round color="primary" v-on="on" icon @click="itemExpenseDialog(item)">
                            <v-icon small>remove_red_eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-card>
        </template>
      </v-data-table>
      <v-dialog v-model="itemDialog" scrollable max-width="900px" persistent>
            <v-card v-if="editedItem.gst_receipt_types_id === 1">
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ editedItem.id }}
                  <span>
                    (
                    {{
                      editedItem.receipt_type
                        ? editedItem.receipt_type.name
                        : ''
                    }}
                    )</span
                  >
                </h2>
                <v-spacer />
                <v-btn v-if="editedItem.item_lines.length > 0" round flat color="primary" @click="showEditCategory">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
                <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()">
                  <v-icon left>print</v-icon> {{ $t('general.print') }}
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="!editCategory">
                <iframe name="cfdi" :srcdoc="cfdiHtml" style="width: 845px; height: 1200px; border: 0">
                </iframe>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-form lazy-validation ref="formf" v-model="validF">
                      <v-flex xs12 md12>
                        <v-autocomplete disabled :items="categories" item-value="id" item-text="name" class="mr-3" :label="$t('categories.name')" v-model="editedItem.gst_categories_id"></v-autocomplete>
                      </v-flex>
                    </v-form>
                    <v-flex xs12>
                      <v-textarea :label="$t('general.comment')" disabled outline v-model="editedItem.comment"></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                        <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="editedItem.item_lines"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 40%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1" auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 20%">
                                <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                              </td>
                              <td style="width: 30%" class="text-sm-center">
                                <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="true"  :items="categories"  color="primary" />
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary darken-1" flat round class="white--text" depressed @click="close">
                  {{ $t('general.close') }}
                </v-btn>
                <v-spacer />
                <div v-if="editedItem.receipt_type">
                  <v-btn v-if="editedItem.receipt_type.id == 1" color="success darken-1" round flat :loading="loadingXML" @click="downloadXML('itemF')">
                    {{ $t('general.downloadXML') }}
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
            <v-card v-else>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ editedItem.id }}
                  <span>({{ editedItem.receipt_type ? editedItem.receipt_type.name : '' }})</span>
                </h2>
                <v-btn class="marginLeft" v-if="editedItem.gst_receipt_types_id === 3" round flat color="primary" @click="showEditCategory">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="!editCategory">
                <v-form lazy-validation ref="form" v-model="valid">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                        <v-flex xs12>
                          <v-text-field :label="$t('general.date')" v-model="editedItem.date" disabled prepend-icon="event"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.country')" disabled prepend-icon="location_on" v-model="editedItem.country.descripcion"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="editedItem.gst_category_id !== null">
                          <v-text-field :label="$t('categories.name')" disabled prepend-icon="list" v-model="editedItem.gst_categories.name"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea :label="$t('general.description')" disabled prepend-icon="forum" v-model="editedItem.description"></v-textarea>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.currency')" disabled prepend-icon="paid" v-model="editedItem.currency.descripcion"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.exchangeRate')" disabled prepend-icon="currency_exchange" v-model="editedItem.exchange"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                          <v-text-field :label="$t('general.supplier')" disabled prepend-icon="store" v-model="editedItem.vendor.name"></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                          <v-text-field :label="$t('general.iva')" disabled prepend-icon="percent" v-model="editedItem.foreign_tax.percent"></v-text-field>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.subtotal')" disabled prepend-icon="attach_money" v-model="editedItem.subtotal"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.total')" disabled prepend-icon="attach_money" v-model="editedItem.total"></v-text-field>
                        </v-flex>
                        <v-flex  xs12 md6>
                          <v-text-field v-if="editedItem.sat_forma_pago != null" :label="$t('general.formaPago')" disabled prepend-icon="credit_card" v-model="editedItem.sat_forma_pago.descripcion"></v-text-field>
                          <v-text-field v-else :label="$t('general.formaPago')" disabled prepend-icon="credit_card"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field :label="$t('general.folioRef')" disabled prepend-icon="article" v-model="editedItem.folio"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea :label="$t('general.comment')" disabled prepend-icon="3p" v-model="editedItem.comment"></v-textarea>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6 layout v-if="dataURL">
                      <v-flex xs12>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                          </a>
                          <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                            <v-icon left>insert_drive_file</v-icon> {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                          <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                        <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="editedItem.item_lines"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 40%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1" auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 20%">
                                <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                              </td>
                              <td style="width: 30%" class="text-sm-center">
                                <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="true"  :items="categories"  color="primary" />
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" flat round class="white--text" depressed @click="close">
                  {{ $t('general.close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'expensesPaidComponent',
  data() {
    const today = new Date().toISOString().slice(0, 10)
    return {
      expensesPaid: [],
      userLogged: {},
      expenseItem: {
        gst_categories: {
          name: '',
        },
        country: {
          descripcion: '',
        },
        currency: {
          descripcion: '',
          c_Moneda: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
      },
      editedItem: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name',
        },
        sat_metodo_pago: {},
        validator_comment: '',
        foreign_tax: {},
        item_lines: []
      },
      editedItemDefault: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name',
        },
        sat_metodo_pago: {},
        validator_comment: '',
        foreign_tax: {},
        item_lines: []
      },
      loadingXML: false,
      search: '',
      dataURL: null,
      itemDialog: false,
      expand: false,
      dialog: false,
      loadingItems: true,
      loadingDataTable: true,
      pagination: {
        sortBy: 'date_sent',
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      settings: {},
      viewCategory: false,
      titleTagCategory: this.$t('general.category'),
      valid: true,
      editCategory: false,
      categories: [],
      cfdiHtml: null,
      validF: true,
      hiddenDownloadLayout: true,
      hiddenCheck: true,
      typeLayout: null,
      loadingDownload: false,
      menuP: false,
      menuP2: false,
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0, 10),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      maxEndDate: today, // límite superior para endDate
      today,
      searchExpensesId: 0
    }
  },
  computed: {
    currencyTag(){
      if(this.settings !== undefined && this.settings.length > 0){
        let currency = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
        return currency === undefined ? 'MXN' : currency.value.c_Moneda
      }
      return ''
    },
    heading() {
      return this.$t('general.paid')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-file-invoice-dollar fa-fw icon-color'
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          sortable: false
        },
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id',
        },
        {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'user.name',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.period'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('general.amount') + ' ' +this.currencyTag,
          align: 'center',
          value: 'suma_total_items',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    conceptsHeader() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        }
      ]
    },
    applyFeaturesBtnERP(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')){
        return true
      }

      return false
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    '$store.state.userLogged'() {
      this.getLogged()
    },
    userLogged() {
      this.getExpensesPaid()
    },
    expenseItem() {
      this.showExpenseItemFile()
    },
    editedItem() {
      this.showExpenseItemFile()
    },
  },
  created() {
    this.userLogged = this.$store.state.userLogged
  },
  methods: {
    searchByExpensesId() {
       this.getExpensesPaid()
    },
    searchByDates() {
      this.searchExpensesId = 0
      this.getExpensesPaid()
    },
    getDateMonthsFrom(date, offset) {
      const d = new Date(date);
      d.setMonth(d.getMonth() + offset);
      return d.toISOString().slice(0, 10);
    },
    limiteRangeDay() {
      if (!this.startDate) return;

      const fourMonthsLater = this.getDateMonthsFrom(this.startDate, 4);
      
      this.maxEndDate = fourMonthsLater > this.today ? this.today : fourMonthsLater;
      
      if(fourMonthsLater < this.today) this.showNotification(this.$t('general.updateEndDate'), 'error', -1)
      
      this.endDate = this.maxEndDate;
    },
    limiteRangeDayEndDate() {
      if (!this.endDate) return;

      const end = new Date(this.endDate);

      const limitStart = new Date(end);

      limitStart.setMonth(limitStart.getMonth() - 4);

      const start = new Date(this.startDate);

      if (start < limitStart) {
        this.showNotification(this.$t('general.updateStartDate'), 'error', -1) 
        this.startDate = limitStart.toISOString().slice(0, 10);
      }
    },
    createLayoutERP(){
      this.typeLayout = 'PAYABLE_EXPENSES_LAYOUT_ERP'
      this.hiddenCheck = !this.hiddenCheck
      this.handleCheckboxChange()
    },
    handleCheckboxChange() {
      let checkExpense = this.expenseChecked()
      
      if(checkExpense == undefined) return this.hiddenBtnLayout(true)
      
      this.hiddenBtnLayout(checkExpense.length > 0)
    },
    expenseChecked(){
      return this.expensesPaid.find(x => x.isChecked == true)
    },
    hiddenBtnLayout(downloadLayout){
      this.hiddenDownloadLayout = downloadLayout
    },
    downloadLayoutERP() {
      this.loadingDownload = true
      
      let downloadLayout =this.getExpensesChecked()
      
      let urlDownload = this.getFeatureDownload()
      
      this.$emit('downloadLayout', {
          listId: downloadLayout.map(obj => obj.id),
          url: urlDownload.pivot.param1,
          typeArchive: urlDownload.pivot.param2,
          context: this,
        })
    },
    getExpensesChecked(){
      return this.expensesPaid.filter(x => x.isChecked == true)
    },
    getFeatureDownload(){
      switch (this.typeLayout) {
        case 'PAYABLE_EXPENSES_LAYOUT_BANK':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_BANK')
        case 'PAYABLE_EXPENSES_LAYOUT_ERP':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')
        case 'PAYABLE_EXPENSES_AUX_XML':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_AUX_XML')
        default:
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')
      }
    },
    downloadXML() {
      this.loadingXML = true
      this.$store.dispatch('downloadXML', {
        event: {
          context: this,
          fileId: this.editedItem.gst_expenses_items_files[0].files_id,
          description: this.editedItem.description,
        },
      })
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    itemExpenseDialog(item) {
      this.editedItem = Object.assign({}, item)
      this.itemDialog = true

      if (this.editedItem.gst_receipt_types_id === 1 && item.gst_expenses_items_files.length > 0) {
        this.$emit('readXmlToHtml', {
          id: item.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsF',
        })
      }
    },
    closeItem() {
      this.expenseItem = {
        gst_categories: {
          name: '',
        },
        country: {
          descripcion: '',
        },
        currency: {
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
      }
      this.dataURL = null
      this.itemDialog = false
      this.loading = false
    },
    getExpensesPaid() {
      this.loadingDataTable = true
      if (this.userLogged.company) {
        this.$emit('get', {
          company: this.userLogged.company[0].id,
          context: this,
        })
      }
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    showExpenseItemFile() {
      if (this.editedItem.gst_receipt_types_id === 2 || this.editedItem.gst_receipt_types_id === 3) {
        if (
          this.editedItem.gst_expenses_items_files !== undefined &&
          this.editedItem.gst_expenses_items_files !== null
        ) {
          if (this.editedItem.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: this.editedItem.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
      }
    },
    downloadReport() {
      this.loadingDownload = true
      this.$emit('downloadReport', {
        context: this,
        company_id: this.userLogged.company[0].id,
      })
    },
    attachFiles(item) {
      this.$router.push('/expenses/files/watch/' + item.id)
    },
    isDisabled(items) {
      if (items && items.length > 0) {
        return false
      } else {
        return true
      }
    },
    getAcuse(id) {
      this.$emit('getAcuse', {
        id,
        context: this,
      })
    },
    showEditCategory(){
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory  ? this.$t('general.category') : this.$t('general.expense') 
    },
    close() {
      this.editedItem = Object.assign({}, this.editedItemDefault)
      this.dataURL = null
      this.itemDialog = false
      this.loading = false
      this.cfdiHtml = null
      this.resetCategories()
    },
    resetCategories(){
      this.editCategory = false
      this.titleTagCategory = this.$t('general.category')
    },
  },
}
</script>

<style lang="css" scoped>
  .marginLeft{
    margin-left: 20%;
  }
  .checkbox-and-data {
    display: flex;
    align-items: center; 
    justify-content: center;
    margin-bottom: -25px;
  }
/*  */
</style>


// WEBPACK FOOTER //
// src/components/expensesPaid.component.vue